export const months = [
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
  "January",
  "February",
  "March",
];

export const quarters = [
  "Q1 (April - June)",
  "Q2 (July - September)",
  "Q3 (October - December)",
  "Q4 (January - March)",
];

export const halfYears = ["H1 (April - September)", "H2 (October - March)"];

export const regularMonths = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];